module.exports = __webpack_public_path__ + "static/media/Korg-N1R-Vibraslap.14f55b7c.wav";